const values = {
  0: "sm:pb-0",
  0.5: "sm:pb-0.5",
  1: "sm:pb-1",
  1.5: "sm:pb-1.5",
  2: "sm:pb-2",
  2.5: "sm:pb-2.5",
  3: "sm:pb-3",
  3.5: "sm:pb-3.5",
  4: "sm:pb-4",
  5: "sm:pb-5",
  6: "sm:pb-6",
  7: "sm:pb-7",
  8: "sm:pb-8",
  9: "sm:pb-9",
  10: "sm:pb-10",
  12: "sm:pb-12",
  14: "sm:pb-14",
  16: "sm:pb-16",
  20: "sm:pb-20",
  24: "sm:pb-24",
  28: "sm:pb-28",
  32: "sm:pb-32",
  36: "sm:pb-36",
  40: "sm:pb-40",
  44: "sm:pb-44",
  48: "sm:pb-48",
  52: "sm:pb-52",
  56: "sm:pb-56",
  60: "sm:pb-60",
  64: "sm:pb-64",
  72: "sm:pb-72",
  80: "sm:pb-80",
  96: "sm:pb-96",
};

export default function getPaddingBottomSm(value) {
  return values[value];
}
